import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/pc/');
gsap.registerPlugin(ScrollTrigger);
export default function Section14() {
    const { useEffect, useLang, Link } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const batteryInfo = {
        subTitle: t('battery_technology'),
        mainTitle: t('battery_technology_sub_title'),
        items: [
            {
                key: 0,
                itemTitle: t('battery_technology_synopsis'),
                text: t('battery_technology_desc'),
                note: t('battery_technology_notice'),
                imgPath: ['section_14_1.webp', 'section_14_1.jpg'],
            },
            {
                key: 1,
                itemTitle: t('battery_technology_synopsis2'),
                text: t('battery_technology_desc2'),
                imgPath: ['section_14_2.webp', 'section_14_2.jpg'],
            },
            {
                key: 2,
                itemTitle: t('battery_technology_synopsis3'),
                text: t.rich('battery_technology_desc3', {
                    line1: (text: string) => (
                        <Link className="ef-link__page" href="/x-stream" newWin>
                            {text}
                        </Link>
                    ),
                    line2: (text: string) => (
                        <Link className="ef-link__page" href="/x-boost" newWin>
                            {text}
                        </Link>
                    ),
                }),
                imgPath: ['section_14_3.webp', 'section_14_3.png'],
            },
        ],
    };

    useEffect(() => {
        // const windowHeight = window.innerHeight
        /* -start- section14 充电技术介绍 动画 */
        const TL = gsap.timeline({
            scrollTrigger: {
                trigger: '.section14',
                start: 'top top',
                end: `+=200%`,
                scrub: 0.5,
                fastScrollEnd: true,
            },
        });
        // head 上移
        TL.to('.section14 .head', {
            duration: 0.5,
            top: '-50vh',
        });
        // P1 hide
        TL.to('.content-0', {
            opacity: 0,
            duration: 1,
        });
        TL.to(
            '.content-0 .left',
            {
                y: -100,
                duration: 1,
            },
            '-=1',
        );

        // P2 show
        TL.to(
            '.content-1',
            {
                opacity: 1,
                duration: 1,
            },
            '-=0.2',
        );
        TL.to(
            '.content-1 .left',
            {
                y: 0,
                duration: 0.5,
            },
            '-=1',
        );

        // P2 hide
        TL.to('.content-1', {
            opacity: 0,
            duration: 1,
        });
        TL.to(
            '.content-1 .left',
            {
                y: -100,
                duration: 0.5,
            },
            '-=1',
        );

        // P3 show
        TL.to(
            '.content-2',
            {
                opacity: 1,
                duration: 1,
            },
            '-=0.3',
        );
        TL.to(
            '.content-2 .left',
            {
                y: 0,
                duration: 0.5,
            },
            '-=1',
        );
        /* -end- section14 充电技术介绍 动画 */
        return () => {
            TL.kill();
        };
    }, []);
    return (
        <div className={`${css.section14} GtmModuleData-section`} data-section-id={css.section14} data-section-title={batteryInfo.mainTitle}>
            <div className="sec14-sticky-wrapper">
                <div className="sec14-sticky-container">
                    <div className="content">
                        <div className="head">
                            <h4 className="subTitle font-family-extrabold">{batteryInfo.subTitle}</h4>
                            <h2 className="mainTitle font-family-extrabold">{batteryInfo.mainTitle}</h2>
                        </div>
                        <div className="imgModule">
                            {batteryInfo.items.map((item, index) => (
                                <div key={item.key} className={`contentItem content-${index}`}>
                                    <div className="left">
                                        <h3 className="title font-family-bold">{item.itemTitle}</h3>
                                        <p className="text font-family-semibolder">{item.text}</p>
                                        {item.note && <p className="note font-family-bold">{item.note}</p>}
                                    </div>
                                    <div className="right">
                                        <div className="imgBox">
                                            <EFPic name={item.imgPath} alt={item.itemTitle} aria-label={item.itemTitle} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
